import { createContext, MutableRefObject, useContext } from 'react';

const defaultContext = {
  visible: false,
  value: '',
};

export type IAutocompleteItem = {
  id: any,
  name: string;
};

export type IAutocomplete = {
  visible?: boolean;
  value: any;
  ref?: MutableRefObject<HTMLElement | null>;
  updateValue?: (next: IAutocompleteItem) => unknown;
  updateVisible?: (next: boolean) => unknown;
};

export const AutocompleteContext = createContext<IAutocomplete>(defaultContext);

export function useAutocompleteContext() {
  return useContext(AutocompleteContext);
}
